module.exports = __webpack_public_path__ + "img/classif.6515944b.png";